import axios, { AxiosRequestConfig } from 'axios';
import { API_CONFIG } from './config';

// Use relative URL in mock mode so MSW can intercept requests
const getBaseURL = () => {
  if (API_CONFIG.useMock) {
    return '/api/v1';
  }
  return import.meta.env.VITE_API_URL || '/api/v1';
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const customInstance = <T>(config: AxiosRequestConfig) => {
  return axiosInstance.request<T>(config).then((response) => response.data);
};
